export const APP_CONFIG = {
  COMPANY_NAME: "STUDIO ROMA SERVICE",
  DOMAIN: "www.disinfestazione-derattizzazione-roma.com",
  SCROLL_BEHAVIOR: "smooth" as ScrollBehavior,
  WHATSAPP_POSITION: {
    BOTTOM: "1.5rem",
    RIGHT: "1.5rem",
  },
  // Header configuration
  MAX_CONTAINER_WIDTH: "max-w-7xl",
  HEADER_HEIGHT: "h-20",
  COMPANY_LOGO_ALT: "STUDIO ROMA SERVICE - Logo",

  // Z-index layers
  Z_INDEX: {
    HEADER: "50",
    DROPDOWN: "60",
    MODAL: "100",
    WHATSAPP: "9999",
  },
} as const;

export const CONTACT_INFO = {
  // Phone numbers
  MAIN_PHONE: "+39 06 644 97261",
  WHATSAPP_PHONE: "+39 351 111 8872",
  EMERGENCY_PHONE: "+39 800 123 456",
  DIRECT_PHONE: "+39 351 1118872",

  // Department phones
  COMMERCIAL_PHONE: "+39 123 456 7891",
  TECHNICAL_PHONE: "+39 123 456 7892",

  // Emails
  PRIMARY_EMAIL: "info@studioromaservice.it",
  MAIN_EMAIL: "info@studioromaservice.it",
  COMMERCIAL_EMAIL: "commerciale@studioromaservice.it",
  TECHNICAL_EMAIL: "assistenza@studioromaservice.it",
  EMERGENCY_EMAIL: "emergenze@studioromaservice.it",

  // WhatsApp
  WHATSAPP_DEFAULT_MESSAGE:
    "Ciao! Vorrei ricevere informazioni sui vostri servizi di disinfestazione e derattizzazione.",
  WHATSAPP_TOOLTIP: "Contattaci su WhatsApp",

  // Address
  ADDRESS: {
    STREET: "Via Roma, 123",
    CITY: "00100 Roma (RM)",
    COUNTRY: "Italia",
    FULL: "Via Roma, 123<br />00100 Roma (RM)<br />Italia",
  },
  
  // Full address for use in footer and legal pages
  FULL_ADDRESS: "Via Roma, 123, 00100 Roma (RM), Italia",

  // Business hours
  BUSINESS_HOURS: "Lun-Ven 8:00-18:00, Sab 8:00-13:00",
  BUSINESS_HOURS_DETAILED: {
    WEEKDAYS: "Lun-Ven 8:00-18:00",
    SATURDAY: "Sab 8:00-13:00", 
    SUNDAY: "Chiuso",
    EMERGENCY: "24/7 Disponibile per emergenze",
  },

  // Service area
  SERVICE_AREA: ["Roma e Provincia"],
} as const;

export const SOCIAL_LINKS = {
  WHATSAPP: `https://wa.me/${CONTACT_INFO.WHATSAPP_PHONE.replace(/[\s\-\(\)\+]/g, "")}`,
  FACEBOOK: "#",
  INSTAGRAM: "#", 
  LINKEDIN: "#",
} as const;

export const LEGAL_INFO = {
  COMPANY_FULL_NAME: "STUDIO ROMA SERVICE - Servizi Ambientali",
  VAT_NUMBER: "11730911002",
  CAPITAL: "€ 10.000,00 i.v.",
} as const;